/*
 * Presentación del borrador (RF-084, RN-132b, RN-134, RN-144).
 *
 * Dos piezas, ninguna bloqueante, ambas sin lógica propia: reciben el estado del
 * hook `useBorrador` y lo pintan. Toda la decisión vive en el hook y en el almacén,
 * que es donde se puede probar.
 */

/**
 * Banda de restauración: SÓLO se muestra cuando de verdad se recuperó un borrador
 * vigente. Un borrador vencido se descarta en silencio y esta banda NO aparece
 * (RN-145c, RN-145d).
 */
export function BandaDeRestauracion({ restauradoHace, alDescartar }) {
  if (!restauradoHace) return null;

  return (
    <div className="aviso n" role="status" data-prueba="banda-de-restauracion">
      <b>Recuperamos lo que estabas escribiendo.</b> Se guardó en este dispositivo {restauradoHace} y
      se restauró tal cual, con los mismos valores. <b>No se recargó nada.</b>
      <div style={{ marginTop: 8 }}>
        <button className="btn sec" type="button" onClick={alDescartar} data-prueba="descartar-borrador">
          Descartar y empezar limpio
        </button>
      </div>
    </div>
  );
}

/**
 * Marca discreta de que hay un borrador escrito en este dispositivo. Aparece sólo
 * con el formulario sucio: un formulario abierto sin cambios no genera borrador
 * (RN-129).
 */
export function MarcaDeBorrador({ sucio }) {
  if (!sucio) return null;

  return (
    <span className="ayuda" data-prueba="marca-de-borrador">
      <b>Borrador guardado en este dispositivo.</b> Se conserva si sales de la aplicación y se borra al
      guardar o al cancelar. No viaja al servidor ni al otro dispositivo.
    </span>
  );
}
